import { hazardous } from "@/settings/hazardous.js";
import { sealTypes } from "@/settings/sealTypes.js";
import { plants } from "@/settings/structure.js";
import { equipmentType } from "@/settings/equipmentType.js";

export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    hazardous,
    sealTypes,
    equipmentType,
    plants
  },

  mutations: {},
  actions: {},
  getters: {}
};
